<template>
    <div class="d-flex justify-center">
        <v-card elevation="7" class="rounded-xl" max-width="450" width="390" min-width="350">
            <v-card flat color="primary" height="120" class="d-flex align-center rounded-b-0 pa-2 position-relative">
                <v-row>
                    <v-col cols="8">
                        <v-img class="ml-3" width="300" max-width="235" src="@/assets/Logo-bt-06.png"></v-img>
                    </v-col>
                    <v-avatar size="110" style="position:absolute; left: 67%; top: 65px; border:3px solid #00a0df;">
                        <v-img v-if="user.fotocarnet" :src="`data:image/jpeg;base64,${user.fotocarnet}`" />
                        <v-img v-else src="@/assets/blank-user-profile.png" />
                    </v-avatar>
                </v-row>
            </v-card>
            <v-card-text class="pt-0 mt-0">
                <v-card-title class="text-body-1 font-weight-bold primary--text">
                    {{ personalSexo }}
                </v-card-title>
                <v-card-text class="my-2 px-5">
                    <div class="font-weight-bold black--text text-h5">LIC. {{ user.nombres }} {{ user.apellido }}
                    </div>
                </v-card-text>
                <v-card-text>
                    <div class="font-weight-bold primary--text text-body-1">MP: {{ user.nroafi }} </div>
                    <div class="font-weight-bold black--text text-body-1">{{ user.tipdoc }}: {{ user.nrodoc }}
                    </div>
                </v-card-text>
            </v-card-text>
            <v-card-text class="d-flex justify-center my-4 ">
                <v-img max-width="300" src="@/assets/credencial/firmas.png"></v-img>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
    },
    data() {
        return {
            month: 0,
            date: '',
            message: 'La presente credencial tiene vencimiento el '
        }
    },
    methods: {
        ...mapActions('auth', ['generarCredencial']),

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatDni(dni) {
            var part = dni.toString().match(/\d{0,3}/g);
            return part.join('.')
        }
    },
    computed: {
        ...mapGetters('auth', ['user']),

        fechaExp() {
            return this.formatDate(this.user.vencimientocredencialactivo)
        },
        personalSexo() {
            switch (this.user.sexo) {
                case "M":
                    return "AFILIADO"
                case "F":
                    return "AFILIADA"
                case "X":
                    return "AFILIADX"
                default:
                    return "AFILIADA/O"
            }
        }
    },

}
</script>


<style>
.rounded-card {
    /* You can adjust the value to control the roundness of the corners */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Optional: Add shadow for a more prominent card effect */
}
</style>